import { ActionId, DecisionType, LegalPieceMacroType, LegalPieceMicroType } from "@/contexts/MessagesContext";
import { UploadingFile } from "@/contexts/MessagesContext";
import { CreditPerSkill, Skill } from "../../types";
import { Type } from "@sinclair/typebox";
import { DateTime } from "luxon";
import { v4 as uuidV4 } from "uuid";
import { base64ToFile } from "@/utils/base64ToFile";
import { fileToUploadingFile } from "@/utils/fileToUploadingFile";

const inputSchema = Type.Object({
  client: Type.String(),
  area: Type.String(),
  document_name: Type.String(),
  decision_type: Type.String(),
  reference_piece: Type.String(),
  timeliness_text: Type.Optional(Type.String()),
  case_breakdown: Type.Optional(Type.String()),
  theses: Type.Optional(Type.String()),
  requests: Type.Optional(Type.String()),
});

const actionId = ActionId.CREATE_ONE_PIECE;

export const createAppealSkill: Skill<typeof inputSchema> = {
  id: "create_appeal",
  name: "Escrever apelação",
  credits: CreditPerSkill.ADVANCED_SKILL,
  inputSchema,
  tags: ["litigation"],
  actionId,
  type: "message",
  getMessage: (input) => {
    const referenceFile = input.reference_piece.startsWith("data:")
      ? fileToUploadingFile(base64ToFile(input.reference_piece))
      : undefined;

    return {
      id: uuidV4(),
      type: "FLOW",
      direction: "SENT",
      author: "Current User",
      date: DateTime.now(),
      status: "READ",
      text: "Criar Recurso",
      actions: [
        {
          id: ActionId.CREATE_ONE_PIECE,
          client: input.client,
          legal_piece_macro_type: LegalPieceMacroType.APPEAL,
          area: input.area,
          legal_piece_micro_type: input.document_name || LegalPieceMicroType.APPEAL,
          decision_type: DecisionType.TERMINATIVE_DECISIONS,
          case_breakdown: input.case_breakdown
            ? {
                source: "TEXT",
                text: input.case_breakdown,
              }
            : undefined,
          timeliness_text: input.timeliness_text,
          theses: input.theses,
          requests: input.requests,
          reference_piece: {
            source: "FILE",
            file: referenceFile,
          },
          text: "Criar Recurso",
        },
      ],
      files: [referenceFile].filter((file): file is UploadingFile => Boolean(file)),
    };
  },
};
